// extracted by mini-css-extract-plugin
export default {"forumlaTableGroup":"FeesOverride_forumlaTableGroup__9uGv6"};